import React from "react";

const MTDTable = ({
  data,
  completeData,
  year,
  onBack,
  onMTDClick,
  selectedStrategy,
}) => {
  
  const filteredMTDs = completeData.map((d) => ({
    strategy: d.strategy,
    ytds: d.ytds.filter((item) => item.year === year),
  }));

  // console.log(filteredMTDs[0].ytds[0].mtds)
  // console.log(filteredMTDs);

  return (
    <div>
      <div className="flex items-center space-x-10">
        <button
          onClick={onBack}
          className="mb-4 py-1 text-xs font-medium px-4 bg-gray-300 text-black rounded"
        >
          Back
        </button>
        <h2 className="text-lg font-bold mb-4">
          MTD Values for Strategy --- {data.strategy} , Year --- {year}
        </h2>
      </div>

      <table className="min-w-full divide-y divide-gray-200">
        <thead className="">
          <tr>
            <th className="border border-gray-300 px-2 py-[1px] text-sm text-left font-medium text-gray-100 uppercase tracking-wider">
              Month
            </th>
            {filteredMTDs[0].ytds[0].mtds.map((mtd, idx) => {
              return (
                <th
                  key={idx}
                  className="border border-gray-300 px-2 py-[1px] text-sm font-medium text-gray-200 uppercase tracking-wider"
                >
                  {mtd.month}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className="">
          {filteredMTDs?.map((item, idx) => (
            <tr
              key={idx}
              className={`cursor-pointer ${idx === selectedStrategy ? ' text-gray-100 bg-amber-700' : 'text-gray-100'}`}
            >
              <td className="border border-gray-300 px-2 py-[1px]">
                {item.strategy}
              </td>
              {item.ytds[0].mtds.map((mtd, mdx) => (
                <td
                  key={mdx}
                  className="border border-gray-300 px-2 py-[1px] text-right  cursor-pointer"
                  onClick={() => onMTDClick(year, mtd.month,idx)}
                >
                  {mtd.mtd_data}
                </td>
              ))}
            </tr>
          ))}
          
        </tbody>
      </table>
    </div>
  );
};

export default MTDTable;










// import React from "react";

// const MTDTable = ({
//   data,
//   completeData,
//   year,
//   onBack,
//   onMTDClick,
//   selectedStrategy
// }) => {
//   const mtds = data.MTDs[year] || {};

//   const filteredMTDs = completeData.map((strategy) => ({
//     strategy: strategy.strategy,
//     mtds: strategy.MTDs[year],
//   }));


//   return (
//     <div>
//       <div className="flex items-center space-x-10">
//         <button
//           onClick={onBack}
//           className="mb-4 py-1 text-xs font-medium px-4 bg-gray-300 text-black rounded"
//         >
//           Back
//         </button>
//         <h2 className="text-lg font-bold mb-4">
//           MTD Values for Strategy --- {data.strategy} , Year --- {year}
//         </h2>
//       </div>

//       <table className="min-w-full divide-y divide-gray-200">
//         <thead className="bg-zinc-700">
//           <tr>
//             <th className="px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider">
//               Month
//             </th>
//             {Object.keys(mtds).map((month) => (
//               <th
//                 key={month}
//                 className="px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider"
//               >
//                 {month}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody className="bg-white divide-y divide-gray-200">
//           {filteredMTDs?.map((item, idx) => (
//             <tr 
//             key={idx}
//             className={`cursor-pointer ${idx === selectedStrategy ? 'bg-gray-300 text-black font-medium' : 'text-gray-500'}`} 
            
//             >
//               <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                 {item.strategy}
//               </td>
//               {Object.entries(item.mtds).map(([month, value]) => (
//                 <td
//                   key={month}
//                   className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 cursor-pointer"
//                   onClick={() => onMTDClick(year, month,idx)}
//                 >
//                   {value}
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default MTDTable;


